// One row of an exchange-bearing dropdown: logo, primary label, an account-type
// chip (Live / Simulated / Alpaca Paper) and the underlying venue.
//
// Shared so the create-bot, create-scanner and backtest pickers stay visually
// identical — they previously ranged from a rich Autocomplete row to plain
// "name (Simulated)" text to bare "name (symbol)".
import React from 'react';
import { Box, Avatar, Chip, Typography } from '@mui/material';
import { exchangeLogo, baseExchangeLabel, exchangeDisplayName, getAccountMeta } from '../config/exchangeConfig';

export default function ExchangeOptionRow({
  exchange,          // the exchange/connection row (drives logo, chip, venue)
  primary,           // optional override, e.g. a bot name instead of the connection name
  secondaryExtra,    // optional extra detail appended to the venue line, e.g. a symbol
  dark = false,      // use the dark AutoTrader palette instead of MUI theme colours
}) {
  const ex = exchange || {};
  const meta = getAccountMeta(ex);
  const label = primary != null && primary !== '' ? primary : exchangeDisplayName(ex);
  const venue = baseExchangeLabel(ex);
  const secondary = [secondaryExtra, venue].filter(Boolean).join(' · ');

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, minWidth: 0, width: '100%' }}>
      <Avatar src={exchangeLogo(ex)} sx={{ width: 26, height: 26, fontSize: 13 }}>
        {(label || '?')[0]}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography noWrap sx={{ fontWeight: 600, fontSize: '14px', color: dark ? '#e7eef6' : undefined }}>
          {label}
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.25, minWidth: 0 }}>
          <Chip size="small" variant="filled" color={meta.chipColor} label={meta.chipLabel} sx={{ height: 20, fontSize: '10.5px' }} />
          {secondary && (
            <Typography
              noWrap
              variant="caption"
              sx={{ opacity: 0.9, color: dark ? '#8593ad' : undefined }}
              color={dark ? undefined : 'text.secondary'}
            >
              {secondary}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
}
